import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/comments.svg'


const _withScopeId = n => (_pushScopeId("data-v-dd5372b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "popUp",
  class: "flex items-center justify-center"
}
const _hoisted_2 = { class: "bg-white rounded-3xl p-6 overflow-auto" }
const _hoisted_3 = { class: "flex flex-col justify-around h-3/4" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "font-bold text-secondary" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-dotted border-main border" }, null, -1))
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-lifebuoy text-xl mr-3" }, null, -1))
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-anchor text-xl mr-3" }, null, -1))
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-rescue text-xl mr-3" }, null, -1))
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = { class: "flex flex-row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical-separator border-main ml-3" }, null, -1))
const _hoisted_19 = { class: "ml-3" }
const _hoisted_20 = { class: "flex flex-row justify-around mb-5" }
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-female text-6xl text-center md:text-5xl" }, null, -1))
const _hoisted_23 = { class: "font-bold text-center" }
const _hoisted_24 = { class: "text-xs uppercase text-center" }
const _hoisted_25 = { class: "flex flex-col" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-male text-6xl text-center md:text-5xl" }, null, -1))
const _hoisted_27 = { class: "font-bold text-center" }
const _hoisted_28 = { class: "text-xs uppercase text-center" }
const _hoisted_29 = { class: "flex flex-col" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-kid text-6xl text-center md:text-5xl" }, null, -1))
const _hoisted_31 = { class: "font-bold text-center" }
const _hoisted_32 = { class: "text-xs uppercase text-center" }
const _hoisted_33 = { class: "flex flex-row justify-around border-dotted border-secondary border-2 rounded-xl p-4 mb-5" }
const _hoisted_34 = { class: "flex flex-row" }
const _hoisted_35 = { class: "flex flex-col" }
const _hoisted_36 = { class: "font-bold text-right text-secondary" }
const _hoisted_37 = { class: "text-3xs uppercase text-right text-secondary" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pregnant text-4xl text-right text-secondary" }, null, -1))
const _hoisted_39 = { class: "flex flex-col" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon text-4xl text-center text-secondary" }, null, -1))
const _hoisted_41 = { class: "font-bold text-center text-secondary" }
const _hoisted_42 = { class: "text-3xs uppercase text-center text-secondary" }
const _hoisted_43 = { class: "flex flex-row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-bib text-3xl text-left text-secondary" }, null, -1))
const _hoisted_45 = { class: "flex flex-col" }
const _hoisted_46 = { class: "font-bold text-left text-secondary" }
const _hoisted_47 = { class: "text-3xs uppercase text-left text-secondary" }
const _hoisted_48 = { class: "text-sm text-center" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-planet text-sm mr-3" }, null, -1))
const _hoisted_50 = { class: "font-bold" }
const _hoisted_51 = {
  key: 0,
  class: "text-sm flex"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "popup-icon"
}, null, -1))
const _hoisted_53 = ["href"]
const _hoisted_54 = { class: "text-sm" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-weather text-xl mr-3" }, null, -1))
const _hoisted_56 = { class: "font-bold" }
const _hoisted_57 = { class: "font-bold" }
const _hoisted_58 = { class: "text-sm" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-marker text-xl mr-3" }, null, -1))
const _hoisted_60 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-camera text-xl mr-3" }, null, -1))
const _hoisted_62 = {
  key: 2,
  class: "flex flex-wrap"
}
const _hoisted_63 = ["src"]
const _hoisted_64 = ["src", "onClick"]

import { store } from "@/main"
import { computed } from "vue"
import { OpsData } from "@/classes/data/OpsData"
import { format } from "@formkit/tempo"


export default /*#__PURE__*/_defineComponent({
  __name: 'OperationDescription',
  setup(__props) {

// import { Colors } from "@/utils/Colors"
const opsData = computed(() => store.getState().popUpData as OpsData)

function setCurrentImage (url: string) {
  store.setImageModalUrl(url)
  store.updateImageModalVisibility(true)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(opsData.value.typeOps), 1)
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(format)(opsData.value.date, "full")), 1),
        _hoisted_7,
        _createElementVNode("p", _hoisted_8, [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("popup.boat")) + ": ", 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(opsData.value.boatType), 1)
        ]),
        _createElementVNode("p", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(_toDisplayString(_ctx.$t("popup.port")) + ": ", 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString(opsData.value.portDisembarkation), 1)
        ]),
        _createElementVNode("p", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, _toDisplayString(opsData.value.nbSurvivor), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("stats.peoples")), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, _toDisplayString(opsData.value.female), 1),
                _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("stats.females")), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("span", _hoisted_27, _toDisplayString(opsData.value.male), 1),
                _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("stats.males")), 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("span", _hoisted_31, _toDisplayString(opsData.value.under18), 1),
                _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("stats.minors")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("span", _hoisted_36, _toDisplayString(opsData.value.pregnantWomen), 1),
                  _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("stats.pregnants")), 1)
                ]),
                _hoisted_38
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("span", _hoisted_41, _toDisplayString(opsData.value.under18unacc), 1),
                _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t("stats.unaccompanied")), 1)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("span", _hoisted_46, _toDisplayString(opsData.value.under5), 1),
                  _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t("stats.children")), 1)
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("span", _hoisted_50, _toDisplayString(opsData.value.nbNationalities.split(";").length.toString()), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("stats.nationalities")), 1)
            ])
          ])
        ]),
        (opsData.value.testimonySrc.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_51, [
              _hoisted_52,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("popup.testimony")) + ": ", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opsData.value.testimonySrc, (src, i) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "font-bold ml-2 testimony-text",
                  key: src+i
                }, [
                  _createElementVNode("a", {
                    href: src,
                    target: "_blank"
                  }, _toDisplayString(opsData.value.testimonyName[i]) + " " + _toDisplayString(i < opsData.value.testimonySrc.length -1 ? "," : ""), 9, _hoisted_53)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_54, [
          _hoisted_55,
          _createTextVNode(_toDisplayString(_ctx.$t("popup.wind")) + ": ", 1),
          _createElementVNode("span", _hoisted_56, _toDisplayString(opsData.value.windForce ? opsData.value.windForce + _ctx.$t("popup.windUnit") : _ctx.$t("popup.unknown")), 1),
          _createTextVNode("- " + _toDisplayString(_ctx.$t("popup.waves")) + ": ", 1),
          _createElementVNode("span", _hoisted_57, _toDisplayString(opsData.value.waveHeight ? opsData.value.waveHeight + "m" : _ctx.$t("popup.unknown")), 1)
        ]),
        _createElementVNode("p", _hoisted_58, [
          _hoisted_59,
          _createElementVNode("span", null, "Lat: " + _toDisplayString(opsData.value.latitude) + " - Lon: " + _toDisplayString(opsData.value.longitude), 1)
        ]),
        (opsData.value.imageSrc.length > 0 || opsData.value.videoSrc.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_60, [
              _hoisted_61,
              _createTextVNode(_toDisplayString(_ctx.$t("popup.videosAndPictures")), 1)
            ]))
          : _createCommentVNode("", true),
        (opsData.value.imageSrc.length > 0 || opsData.value.videoSrc.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opsData.value.videoSrc, (url) => {
                return (_openBlock(), _createElementBlock("video", {
                  key: url,
                  class: "max-w-[50%] p-1",
                  controls: "",
                  controlsList: "nodownload"
                }, [
                  _createElementVNode("source", {
                    src: url,
                    type: "video/mp4"
                  }, null, 8, _hoisted_63)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opsData.value.imageSrc, (url) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: url,
                  class: "max-w-[50%] p-1 cursor-pointer",
                  src: url,
                  onClick: ($event: any) => (setCurrentImage(url))
                }, null, 8, _hoisted_64))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})